<template>
  <div class="app-content">
    <div class="bg-gray pb-5" >
      <div class="container bg-gray" id="try_quiz">
        <div class="row pt-4 mb-2" v-if="!show_result">
          <div class="col-12 col-md-12 mx-auto py-2 text-center">
            <h4 class=" mb-12">{{$t("message.study_mode")}}</h4>

            <div class="row mt-4">
              <div class="col-12 col-md-12 text-left order-2 order-md-1">
                <router-link :to="'/mypage'">
                  <p class="text-navy">＜<span class="under">{{$t("message.to_mypage")}}</span></p>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div v-for="(question, index) in questions" :key="question.id" v-show="is_index == index">
          <div class="row pt-2">
            <div class="col-12 mb-2">
              <b-card class="px-5 py-4">
                <h5>{{ index + 1 }}/{{ questions.length }}{{$t("message.order_question")}}<span v-if='question.midle_category != null'>({{question.midle_category}})</span></h5>
                <p class="mb-0">{{translated_title[question.id]}}</p>
                <div v-if="photos[index].length > 0" class="text-center">
                  <img :src="photos[index][0]" style="width: 80%;"/>
                </div>

                <radio-choice :gt="answers[question.id]['answer']" :choices="choices[question.id]" v-if="question.question_type == 'radio'"></radio-choice>
              </b-card>
              <two-choice :gt="answers[question.id]['answer'] "  v-if="question.question_type == 'true_or_false'"></two-choice>
              <checkbox-choice :gt="answers[question.id]['answer'] " :choices="choices[question.id]" v-if="question.question_type == 'checkbox'"> </checkbox-choice>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-12 mb-4 ">
                <p class="text-center current bg-blue mb-0" v-if="checkAnswer(answers[question.id]['answer'], question)">{{$t("message.correct_answer")}}</p>
                <p class="text-center current bg-blue mb-0" v-else>{{$t("message.no_correct_answer")}}</p>
              <b-card class="px-3 px-md-5 py-3">
                <h3 class="answer-label" v-if="question.question_type == 'radio'"><span>{{$t("message.correct_answer_normal")}}:</span> {{ choices[question.id][question.answer].label }}</h3>
                <p class="mb-0" >{{ translated_commentary[question.id]}}</p>
              </b-card>
            </div>
          </div>
          <div class="row mt-3" v-if='index != 0'>
            <div class="col-3 mb-2 text-center ml-auto">
              <b-button  class="next py-2 px-4" @click="before()" > ←{{$t("message.before")}} </b-button>
            </div>
            <div class="col-3 mb-2 text-center mr-auto">
              <b-button  class="next py-2 px-4" @click="next()" > {{$t("message.next")}}→ </b-button>
            </div>
          </div>
          <div class="row mt-3" v-else>
            <div class="col-12 mb-2 text-center">
              <b-button  class="next py-2 px-4" @click="next()" > {{$t("message.next")}}→ </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gray pb-5" v-if="show_result">
      <div class="container">
        <div class="row pt-4 mb-2">
          <div class="col-12 col-md-8 mx-auto py-2 text-center">
            <b-card class="px-5 py-4">
            <h4 class=" mb-12">{{$t("message.finish_all")}}</h4>

            <div class="row mt-4">
              <div class="col-12 text-center px-md-0">
                <p >
                  {{$t("message.your_score")}}<b class="score">{{examination.results}}{{$t("message.score")}}</b>{{$t("message.is")}}<br>
                  ({{questions.length + $t("message.of_question") + current_num  + $t("message.question_current")}})
                </p>
              </div>
              <div class="col-12 text-center pt-4">
                <p> {{$t("message.result_description")}} </p>
              </div>
            </div>

            <div class="row mt-3" v-if='index != 0'>
              <div class="col-12 mb-2 text-center">
                <b-button  class="next py-2 px-4" @click="before()" > ←{{$t("message.before")}} </b-button>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 mb-2 text-center">
                <router-link :to="'/pastedQuizList'">
                  <b-button  class="next py-2 px-4"  > {{$t("message.back_solved_problem_list")}} > </b-button>
                </router-link>
              </div>
              <div class="col-12 mb-2 text-center">
                <b-button  class="retry py-2 px-4" @click="retry"> {{$t("message.again_retry")}} > </b-button>
              </div>
            </div>
          </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TwoChoice from "@/components/User/Quiz/TwoChoice";
import RadioChoice from "@/components/User/Quiz/RadioChoice";
import CheckboxChoice from "@/components/User/Quiz/CheckboxChoice";
import axios from 'axios';
export default {
  components: {
    TwoChoice,
    RadioChoice,
    CheckboxChoice
  },
  data () {
    return {
      qId: this.$route.params.qId,
      is_index: 0,
      show_result: false,
      idToken: localStorage.idToken,
      examination: {},
      questions: [],
      answers: {},
      choices: {},
      photos: {},
      current_num: 0,
      translated_title: {},
      translated_commentary: {},
    }
  },
  methods: {
    next(){
      /*
        this method is is_index add 1 . if now proble is last, show_result is true
      */
      this.is_index += 1
      this.$scrollTo('#try_quiz')
      if( this.questions.length == this.is_index ){
        this.show_result = true
      }
    },
    before(){
      this.is_index -= 1
      this.$scrollTo('#try_quiz')
      this.show_result = false

    },
    retry(){
      /*
        this method is is_index valiable value is reflesh and show_result set false
      */
      this.is_index = 0
      this.show_result = false
    },
    checkAnswer(is_ans, q) {
      /*
        既に回答された答え(is_ans)を元に、答えの正答を確認しbooleanで返す。
        Parameters
        ----------
        is_ans : Integer
            現在の問題の回答。 ex) "1"
        q : Object
            現在の問題情報
        Returns
        ----------
         : Boolean
            trueが正解、falseが不正解
      */
      if(q.question_type == 'true_or_false') {
        return is_ans == q.answer
      } else if(q.question_type == 'radio') {
        return is_ans == q.answer
      }else{
        return is_ans == q.answer
      }
    },
    translate_question(question, id) {
      /*
        質問情報からタイトルと解説を取り出し翻訳し、translated_title変数、translated_commentary変数に格納する。{question_id: translated_title} {question_id: translated_commentary}
        Parameters
        ----------
        question : Object
            質問情報
        id: Integer
            問題ID
      */
      var lang = this.LANGUAGE_LIST[this.memberInfo.language]
      if(lang != "ja") {
        var info = [question.title, question.commentary]
        axios
          .post(process.env.VUE_APP_API + "/trial_examination/translate", {text: info.join("|"), lang: lang}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then((res) => {
            var tras_info = res.data.text.replace( /&#39;/g, "'").split('|')
            this.translated_title[id] = tras_info[0]
            this.translated_commentary[id] = tras_info[1]
          }).catch(() => {})
      }else{
        this.translated_title[id] = question.title
        this.translated_commentary[id] = question.commentary
      }
      this.translated_title = Object.assign({}, this.translated_title)
      this.translated_commentary = Object.assign({}, this.translated_commentary)
    },
    async choices_translate(contents_strlist,id) {
      /*
        問題の選択肢を翻訳し、choices変数に格納する。{question_id: {"label": translated_label, "value": label_index}}
        Parameters
        ----------
        contents_strlist : String
            選択肢の情報が入っている。"[{label: text, is_ans: boolean}]"
        id: Integer
            問題ID
      */
      var lang = this.LANGUAGE_LIST[this.memberInfo.language]
      if(lang != "ja") {
        var choice = []
        await JSON.parse(contents_strlist).forEach((content, index) => {
          axios
          .post(process.env.VUE_APP_API + "/trial_examination/translate", {text: content.label, lang: lang})
          .then((res) => {
            choice.push({"label": res.data.text, "ia_answer": content.is_answer, value: index})
          }).catch(() => {})
        })
        this.choices[id] = choice
      }else{
        var choice_ja = []
        JSON.parse(contents_strlist).forEach((content, index) => {
          content["value"] = index
          choice_ja.push(content)
        })

        this.choices[id] = choice_ja
      }
      this.choices = Object.assign({}, this.choices)

    },
  },
  async mounted(){
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    // 試験情報、問題情報と回答した内容を取得し、それぞれをexamination、questions、answersに格納する
    await axios
    .get(process.env.VUE_APP_API + "/trial_examination/" + this.qId, {headers: {'Authorization': 'Bearer ' + this.idToken}})
    .then(response => {
      this.examination = response.data.trial_examination
      if(this.examination.results == null){
        this.examination.results = 0
      }
      this.questions = response.data.questions

      response.data.answers.forEach((item) => {
        this.answers[item.question_id] = item
      })
    }).catch(error => {
      console.log('this is error', error)
    })
    // 問題情報を翻訳する。
    await this.questions.forEach((item, i) => {
      this.photos[i] = (item.photos || "" ).split(",")
      this.translate_question(item, item.id)
      if(item.question_type == 'radio') {
        this.choices_translate(item.content, item.id)
      }
      if(this.questions.length == i + 1){
        this.$store.commit('setLoading', false)
      }
      if(this.answers[item['id']]['answer'] == item['answer']){
        this.current_num += 1
      }
    })
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user
    })
  },

}
</script>

<style scoped lang="scss">
.bg-blue{
  background:#000054;
  color: #FFFFFF;
  height: 70px;
}

.current{
  font-size: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.index_orange{
  font-weight: bold;
  color: #F29147;
}

.index_red{
  font-weight: bold;
  color: #E60028;
}

.recomend-card{
  background:linear-gradient(67.94deg, #000054 0%, rgba(0, 0, 84, 0.5) 100%);
}
.solved-probrem{
  background: linear-gradient(67.94deg, #00BDE6 0%, rgba(0, 189, 230, 0.5) 100%);
}

.look_solved{
  background: linear-gradient(67.94deg, #F29147 0%, rgba(242, 145, 71, 0.5) 100%);
}

.start{
  background: #F29147 !important;
  color: #FFFFFF !important;
  font-size: 16px;
  border-color: #F29147!important;

}

.mb-12{
  margin-bottom: 12px;
}

.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}

.score{
  font-size: 30px;
}
.retry{
  background: #FFFFFF !important;
  color: #F29147;
  font-size: 14px;
  border-color: #FFFFFF!important;
  width: 90%
}
.answer-label {
  font-size: 22px;
  text-align: center;
  span {
    font-size: 20px;
  }
}
</style>
